<mat-toolbar style="display: flex; gap: 8px;">
	<h2>Merch</h2>

	<a style="margin-left: 64px;" mat-button routerLink="/merch/inventory" routerLinkActive="active">Inventory</a>

	<div style="flex: 1"></div>
	<mat-form-field subscriptSizing="dynamic">
		<mat-label>Stock</mat-label>
		<mat-select [formControl]="inStock">
			<mat-option value="any">Any</mat-option>
			<mat-option value="available">In-Stock</mat-option>
			<mat-option value="unavailable">Out of stock</mat-option>
		</mat-select>
	</mat-form-field>

	<mat-form-field subscriptSizing="dynamic">
		<mat-label>Availability</mat-label>
		<mat-select [formControl]="visibility">
			<mat-option value="all">All</mat-option>
			<mat-option value="public">Online</mat-option>
			<mat-option value="private">Pickup</mat-option>
		</mat-select>
	</mat-form-field>

	<mat-form-field subscriptSizing="dynamic">
		<mat-label>Categories</mat-label>
		<mat-select [formControl]="categories" multiple>
			<mat-option *ngFor="let topping of catList" [value]="topping">{{topping}}</mat-option>
		</mat-select>
	</mat-form-field>

	<button mat-button matTooltip="Add New Merch" (click)="addItem()">Add Item</button>

</mat-toolbar>
<div style="display: grid; grid-template-columns: repeat(5, 1fr); justify-content: space-between;">
	<div *ngFor="let item of filteredMerch;" >
		<div>
			<div *ngFor="let image of item.images" (click)="editItem(item, $event)">
				<div style="width: 19.5vw; height: 19.5vw; box-sizing: content-box;
  background-size: cover; background-position: center, center;" [style.backgroundImage]="'url(https://support.4zzz.org.au/' + image.src +'), url(https://support.4zzz.org.au/4zzz.svg)'" ></div>
			</div>			
		</div>
	</div>
</div>